<template>
  <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      title="提示"
      width="30%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
  >
    <span v-if="permissionList.kaifapiao">收款成功！请问是否需要打印收据或开具发票？</span>
    <span v-if="!permissionList.kaifapiao">收款成功！请问是否需要打印收据？</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button v-if="permissionList.kaifapiao" @click="handleButton1" type="primary">开具发票</el-button>
        <el-button @click="handleButton2" type="primary">打印收据</el-button>
        <el-button @click="handleButton3">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getFeePayByPaybillNo } from '@/api/v4ward/digitaltickets/InvoiceCommon.js';
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      form:{

      },
      dialogVisible: false
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        kaifapiao: this.vaildData(this.permission.paydetailquery_kaifapiao, false),
      };
    },
  },
  methods: {
    //父组件调用
    openDialog(params) {
      console.log('付款后，开启自定义弹框');
      this.form.orderNo = params.orderNo;
      this.form.businessType = params.businessType;
      this.form.roomName = params.roomName;
      console.log('this.form>>>', this.form);
      this.dialogVisible = true;
    },
    handleButton1() {
      console.log('开发票');
      //获取缴费记录
      if(this.form.businessType == '11'){
        //查看one_fee_pay中的数据，一般情况下，business不会等于其他值
        getFeePayByPaybillNo({paybillNo:this.form.orderNo}).then(({data})=>{
          console.log('获取feePay中的数据', data);
          if(data.feePayId){
            const params = {
              feePayId:data.feePayId,
              businessType:11,
              payAmount:data.payAmount,
              communityId:data.communityId,
              roomName:this.form.roomName,
            };
            this.$emit('openInvoiceApplyDialog', params);
            this.dialogVisible = false;
            this.form = {};
          }
        });
      }
    },
    handleButton2() {
      console.log('打印票据');
      this.$emit('openPrintDialog', this.form.orderNo);
      this.dialogVisible = false;
      this.form = {};
    },
    handleButton3() {
      console.log('取消了');
      this.form = {};
      this.dialogVisible = false;
    },
  }
};
</script>
